import { Dispatch, SetStateAction, useState } from "react";

function useStateWithLocalStorage<S>(
  initialState: S | (() => S),
  key: string
): [S, Dispatch<SetStateAction<S>>] {
  const [state, setInnerState] = useState<S>(() => {
    const localStorageState = localStorage.getItem(key);

    if (localStorageState) {
      try {
        return JSON.parse(localStorageState);
      } catch (error) {
        console.log(error);
        localStorage.removeItem(key);
        return initialState instanceof Function ? initialState() : initialState;
      }
    } else {
      return initialState instanceof Function ? initialState() : initialState;
    }
  });

  const setState = (value: S | ((prevState: S) => S)) => {
    setInnerState((prevState) => {
      const newState = value instanceof Function ? value(prevState) : value;
      localStorage.setItem(key, JSON.stringify(newState));
      return newState;
    });
  };

  return [state, setState];
}

export default useStateWithLocalStorage;
